import { Controller } from "@hotwired/stimulus"
import { formatBRL } from "../utils/format"

// Shows the last cancellable sale for a loaded card and offers the way into the
// cancellation screen, where the operator picks which items come back. The route
// nests the sale id in the path, so the link's href is built client-side once
// the cancellable lookup resolves.
export default class extends Controller {
  static values  = { cancellableUrl: String, cancelUrlBase: String }
  static targets = ["panel", "summary", "link"]

  connect() {
    this._loadRequestId = 0
    this._boundOnCardLoaded = this.#onCardLoaded.bind(this)
    this.element.addEventListener("card:loaded", this._boundOnCardLoaded)
  }

  disconnect() {
    this.element.removeEventListener("card:loaded", this._boundOnCardLoaded)
  }

  async #onCardLoaded({ detail: { code } }) {
    this.#hide()
    if (!code) return

    const requestId = ++this._loadRequestId

    let response
    try {
      response = await fetch(`${this.cancellableUrlValue}?code=${encodeURIComponent(code)}`, { headers: { Accept: "application/json" } })
    } catch {
      return
    }
    // A newer card was loaded while this fetch was in flight — its own
    // handler already owns the panel, so this stale response is dropped.
    if (requestId !== this._loadRequestId) return
    if (!response.ok) return

    const { cancellable_sale: sale } = await response.json()
    if (!sale) return

    // Only what is still cancellable is named here: a sale that already gave
    // part of itself back cannot give the original charge back again.
    const items = sale.items
      .filter((line) => line.remaining_quantity > 0)
      .map((line) => `${line.remaining_quantity}x ${line.name}`)
      .join(", ")
    this.summaryTarget.textContent = `Última venda: ${formatBRL(sale.net_amount)} (${items})`
    this.linkTarget.href = `${this.cancelUrlBaseValue}/${sale.id}/cancellation/new`
    this.panelTarget.hidden = false
  }

  #hide() {
    this.panelTarget.hidden = true
  }
}
